"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intlDateTimeRangeFormat = exports.intlDateTimeFormatToParts = exports.intlDateTimeFormatResolvedOptions = exports.intlDateTimeFormat = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isSameYear = _interopRequireDefault(require("date-fns/isSameYear"));

var _isSameDay = _interopRequireDefault(require("date-fns/isSameDay"));

var _functional = require("./functional");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var formatIncludesTime = function formatIncludesTime(format) {
  return format && (format.hour || format.minute || format.second);
};
/**
 * Memoized access to the the Intl.DateTimeFormat API
 */


var intlDateTimeFormatCurried = (0, _functional.memoizeCurry)(function (format, locale) {
  return new Intl.DateTimeFormat(locale, format);
}, 1);
/**
 * Format a date using the Intl.DateTimeFormat API. See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
 * for formatting options.
 */

var intlDateTimeFormat = function intlDateTimeFormat(date, format) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en-US";
  return intlDateTimeFormatCurried(format)(locale).format(date);
};
/**
 * Format a date range using the Intl.DateTimeFormat API (uses some custom
 * logic as the Intl formatRange method is not well supported). See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
 * for formatting options.
 */


exports.intlDateTimeFormat = intlDateTimeFormat;

var intlDateTimeRangeFormat = function intlDateTimeRangeFormat(startDate, endDate, format) {
  var locale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "en-US";

  // If we were given the exact same date times, or date times on the same day
  // and we're not showing time components, then just render one.
  if (startDate === endDate || (0, _isSameDay["default"])(startDate, endDate) && !formatIncludesTime(format)) {
    return [intlDateTimeFormat(startDate, format, locale), null];
  } // If we're showing dates (no time components) and the start & end dates fall
  // in the same year, don't show the year for the start date (e.g. show
  // "May 23 - May 25, 2020" instead of "My 23, 2020 - May 25, 2020").
  else if ((0, _isSameYear["default"])(startDate, endDate) && !formatIncludesTime(format)) {
    var startFormat = Object.assign({}, format, {
      year: undefined,
      era: undefined
    });
    return [intlDateTimeFormat(startDate, startFormat, locale), intlDateTimeFormat(endDate, format, locale)];
  } // If we're showing a time range that occurs on a single day, don't show the
  // timezone in the first date and don't show the date in the second date (e.g.
  // show "January 1, 2020, 8 AM - 10 AM PST" instead of
  // "January 1, 2020, 8 AM PST - January 1, 2020, 10 AM PST")
  else if ((0, _isSameDay["default"])(startDate, endDate) && formatIncludesTime(format)) {
    var _startFormat = Object.assign({}, format, {
      timeZoneName: undefined
    });

    var endFormat = Object.assign({}, format, {
      weekday: undefined,
      year: undefined,
      month: undefined,
      day: undefined,
      era: undefined
    });
    return [intlDateTimeFormat(startDate, _startFormat, locale), intlDateTimeFormat(endDate, endFormat, locale)];
  } // If none of our special cases matched just return each fully formed date
  else {
    return [intlDateTimeFormat(startDate, format, locale), intlDateTimeFormat(endDate, format, locale)];
  }
};
/**
 * Format to parts a date using the Intl.DateTimeFormat API. See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
 * for formatting options.
 */


exports.intlDateTimeRangeFormat = intlDateTimeRangeFormat;

var intlDateTimeFormatToParts = function intlDateTimeFormatToParts(date, format) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en-US";
  return intlDateTimeFormatCurried(format)(locale).formatToParts(date) // HACK: Some implementations of the Intl API lower-case the "P" in
  // "dayPeriod" (looking at you Node...)
  .map(function (part) {
    return part.type === "dayperiod" ? _objectSpread(_objectSpread({}, part), {}, {
      type: "dayPeriod"
    }) : part;
  });
};
/**
 * Get resolved options from a format/locale using the Intl.DateTimeFormat API. See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/resolvedOptions
 * for options.
 */


exports.intlDateTimeFormatToParts = intlDateTimeFormatToParts;

var intlDateTimeFormatResolvedOptions = function intlDateTimeFormatResolvedOptions(format) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
  // Merge in the default options because some environments may leave certain
  // options off (like hourCycle in Node...).
  var defaultOptions = {
    locale: "en-US",
    calendar: "gregory",
    numberingSystem: "latn",
    timeZone: "UTC",
    hourCycle: "h12",
    hour12: true,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    fractionalSecondDigits: 0
  };
  return _objectSpread(_objectSpread({}, defaultOptions), intlDateTimeFormatCurried(format)(locale).resolvedOptions());
};

exports.intlDateTimeFormatResolvedOptions = intlDateTimeFormatResolvedOptions;